import { FunctionalInterface } from "@/backend/models/functionalInterface";
import { InterfaceInstanceFunction } from "@/backend/models/interfaceInstanceFunction";
import { InterfaceFunctionController } from "@/frontend/controllers/interfaceInstanceFunctionController";
import { RightCaret } from "@/frontend/SVGs/RightCaret";
import { I18n } from "@/i18n/I18n";
import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export function SelectFunctionalInterfaceModal(props: { setShowModal: (show: boolean) => void, functionalInterfaces: FunctionalInterface[], onSubmit: (options: {functionalInterfaceId: string, functionId: string} ) => void, selectingFunction?: boolean }) {
  const { setShowModal, functionalInterfaces, onSubmit, selectingFunction } = props;
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFunctionalInterface, setSelectedFunctionalInterface] = useState<FunctionalInterface | null>(null);
  const [selectedInstanceFunctions, setSelectedInstanceFunctions] = useState<InterfaceInstanceFunction[]>([]);
  const [selectedFunctionId, setSelectedFunctionId] = useState<string>('');

  const filteredFunctionalInterfaces = functionalInterfaces.filter((functionalInterface) => 
    functionalInterface.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const onSetSelectedFunctionalInterface = async (functionalInterface: FunctionalInterface) => {
    setSelectedInstanceFunctions([]);
    setSelectedFunctionId('');
    setSelectedFunctionalInterface(functionalInterface);
    const response = await new InterfaceFunctionController().readInterfaceFunctionsByFunctionalInterfaceId(functionalInterface.id);
    if(!response.errors) {
      setSelectedInstanceFunctions(response.interfaceFunctions.map((f) => new InterfaceInstanceFunction(f)));
    }
  };

  return (
    <Modal show onHide={() => setShowModal(false)} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Functional Interface Manager</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='d-flex gap-2 flex-fill'>
          <div className='card p-2 w-50'>
            <strong>{I18n.get('availableFunctionalInterfaces')}</strong>
            <Form.Control
              type="text"
              placeholder={I18n.get('searchFunctionalInterfaces')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className='border-left-0'
            />
            {filteredFunctionalInterfaces.map((functionalInterface) => (
              <button className={`card mt-2 w-100 ${selectedFunctionalInterface?.id === functionalInterface.id ? 'border-primary bg-primary-subtle' : 'bg-light'}`} key={functionalInterface.id} onClick={() => void onSetSelectedFunctionalInterface(functionalInterface)}>
                <div className='p-2'>
                  <div className='d-flex justify-content-between'>
                    <strong>{functionalInterface.name}</strong>
                    <div className='text-secondary'><RightCaret /></div>
                  </div>
                  <small className='d-flex justify-content-start'>{functionalInterface.description}</small>
                </div>
              </button>
            ))}
          </div>
          <div className='card w-50 p-2'>
            <strong>{selectingFunction ? I18n.get('selectFunctionToInvoke') : I18n.get('preview')}</strong>
            {selectedFunctionalInterface && <div className='card p-2 bg-primary-subtle mt-2'>
              <strong>{selectedFunctionalInterface.name}</strong>
              <small>{selectedFunctionalInterface.description}</small>
              <small className='fw-bold mt-2'>{I18n.get('functions')}:</small>
              {selectedInstanceFunctions.map((f) => (
                <button 
                  className={`card align-items-start p-2 mt-2 ${selectingFunction && selectedFunctionId === f.id ? 'border-primary' : 'bg-light'}`} 
                  key={f.id} onClick={() => setSelectedFunctionId(f.id)}
                  aria-label={I18n.get('selectFunction', { function: f.functionTitle })}
                >
                  <code>{f.functionTitle}</code>
                </button>
              ))}
              {!selectingFunction && <small className='py-2'>{I18n.get('functionalInterfaceSelectFinePrint')}</small>}
              <Button className='btn btn-primary w-100' disabled={selectingFunction && !selectedFunctionId} onClick={() => void onSubmit({ functionalInterfaceId: selectedFunctionalInterface.id, functionId: selectedFunctionId })}>{I18n.get('addToTemplate')}</Button>
            </div>}  
          </div>
        </div>
      </Modal.Body>
  </Modal>
  );
}
